export default "__VITE_ASSET__88145846__"